module.exports = __webpack_public_path__ + "img/2_04b449a61.png";